module.exports = __webpack_public_path__ + "img/upload1.35b0bd8c.png";